import { mapMutations }   from "vuex";
import Tls            from "@/services/Tls";
import ServiceTls         from "@/services/ServiceTls";
import GroupMap           from "@/components/Group/Map";
import GroupInstructions  from "@/components/Group/Instructions";
import MessagesList       from "@/components/ServiceTls/MessagesList";
import NewServiceTlsCase  from "@/components/ServiceTls/NewCase";

// ==================
// NAME
// ==================
const name = "ServiceTlshow";

// ==================
// DATA
// ==================
const newMessage = {
	message: null
};

const data = function () {
	return {
		loading:         false,
		instructions:    [],
		messages:        [],
		group:           {},
		request:         {},
		newMessage:      { ...newMessage },
	};
};

// ==================
// METHODS
// ==================
const toastMessage = function (message) {
	this.$toasted.show(message, {
		position: "bottom-center",
		duration: 3000,
		action: {
			text: "Fermer",
			onClick: (e, toastObject) => {
				toastObject.goAway(0);
			}
		}
	});
};

const fetchData = function () {
	const { caseId } = this.$route.params;

	ServiceTls.Cases.find(caseId).then(response => {
		if (response.case) {
			this.request = response.case;

			this.addServiceTlsCase(this.request);

			Tls.Groups.find(this.request.group_id).then(response => {
				this.group = response.group;
			}).catch(_error => {
				this.group = {};
				toastMessage.bind(this)("Impossible de chargé le groupe");
			});
		}
	});
};

const submitMessageForm = function (e) {
	e.preventDefault();

	if (this.newMessage.message) {
		const { caseId }  = this.$route.params;
		const { message } = this.newMessage;

		ServiceTls.Messages.create({ caseId, message }).then(_ => {
			this.newMessage = { ...newMessage };

			toastMessage.bind(this)("Message ajouté !");

			this.$refs.messagesList.refresh();
		}).catch(error => {
			toastMessage.bind(this)(error.message);
		});
	} else {
		toastMessage.bind(this)("Message doit être rempli !");
	}
};

// ==================
// COMPONENT
// ==================
export default {
	name,
	data,
	components: {
		GroupMap,
		GroupInstructions,
		MessagesList,
		NewServiceTlsCase
	},
	methods: {
		...mapMutations(["addServiceTlsCase"]),
		fetchData,
		submitMessageForm,
	},
	mounted() {
		this.fetchData();
		document.body.classList.add("CaseShow");
	},
	watch: {
		"$route": "fetchData"
	},
	destroyed() {
		document.body.classList.remove("CaseShow");
	}
};
